<template>
  <div
    v-if="this.errosGerais.Message"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          {{ this.errosGerais.Message }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.errosValidacaoGeral.length && !this.loading"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          <ul>
            <li v-for="value in this.errosValidacaoGeral" :key="value">
              {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column flex-lg-row">
    <div class="d-flex flex-column mb-7 me-lg-8 min-w-lg-300px min-w-xl-375px">
      <div class="card card-flush py-5">
        <div class="card-header">
          <h3 class="card-title">
            <img
              src="media/icons/duotune/general/gen019.svg"
              class="me-2"
            />Painel do Gestor
          </h3>
        </div>
        <div class="card-body pt-0">
          <div
            id="menuPainelGestor"
            class="menu menu-rounded menu-column menu-title-gray-700 menu-icon-gray-400 menu-arrow-gray-400 menu-bullet-gray-400 menu-arrow-gray-400 menu-state-bg fw-semibold"
            data-kt-menu="true"
          >
            <div class="menu-item">
              <a
                id="mAtualizaBase"
                @click="this.menuClick('mAtualizaBase')"
                :class="[
                  this.idMenuSelecionado === 'mAtualizaBase' && 'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
                  </span>
                </span>
                <span class="menu-title">Atualiza Base</span>
              </a>
            </div>
            <div class="menu-item">
              <a
                id="mTabelaIbpt"
                @click="this.menuClick('mTabelaIbpt')"
                :class="[this.idMenuSelecionado === 'mTabelaIbpt' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/files/fil002.svg" />
                  </span>
                </span>
                <span class="menu-title">Tabela Ibpt</span>
              </a>
            </div>
            <div class="menu-item" v-if="this.exibirAgenciaBoletoLicenca">
              <a
                id="mAgenciaBoletoLicenca"
                @click="this.menuClick('mAgenciaBoletoLicenca')"
                :class="[
                  this.idMenuSelecionado === 'mAgenciaBoletoLicenca' &&
                    'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/finance/fin001.svg" />
                  </span>
                </span>
                <span class="menu-title">Agência - Boleto Licença</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-row-fluid mb-7 min-w-lg-375px">
      <div class="card card-flush py-5">
        <div class="d-flex flex-wrap flex-sm-nowrap">
          <div class="flex-grow-1">
            <div
              class="d-flex justify-content-between align-items-start flex-wrap mb-0"
            >
              <div class="card-header border-bottom-0">
                <h3 class="card-title">
                  {{ this.returnTitle() }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mAtualizaBase'"
          class="card-body pt-5"
        >
          <a href="#" id="idmAtualizaBase"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div class="card border border-rounded border-gray-300 mb-4 p-6">
                <h4 class="text-primary ms-4 mb-4">
                  Restrições Administrativas Padrão
                </h4>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione a restrição à ser atualizada</label
                      >
                      <Multiselect
                        :id="`multiselectRestricaoAdministrativaPadrao`"
                        :ref="`multiselectRestricaoAdministrativaPadrao`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione a restrição à ser atualizada"
                        v-model="this.restricaoAdministrativaPadraoSelecionada"
                        :searchable="true"
                        :canDeselect="true"
                        :options="
                          this.camposOrdenados(
                            this.restricoesAdministrativasPadrao
                          )
                        "
                        placeholder="Atualizar todas as restrições"
                        @clear="
                          this.focusSelect(
                            `multiselectRestricaoAdministrativaPadrao`
                          )
                        "
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-auto mb-4">
                    <div class="fv-row">
                      <button
                        @click="confirmarRestricaoAdministrativaPadrao()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Iniciar a atualização da restrição"
                        class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-5"
                      >
                        <i class="bi bi-check-lg ms-1 fs-2"></i>
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
                <h4 class="text-primary ms-4 mb-4">
                  Grupo de Restrições Administrativas
                </h4>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione o grupo de restrição à ser atualizado</label
                      >
                      <Multiselect
                        :id="`multiselectGrupoRestricao`"
                        :ref="`multiselectGrupoRestricao`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione o grupo de restrição à ser atualizado"
                        v-model="this.grupoRestricaoSelecionado"
                        :searchable="true"
                        :canDeselect="true"
                        :options="this.retornaOptionsTipo(this.tipoUsuario)"
                        placeholder="Atualizar todos os grupos"
                        @clear="this.focusSelect(`multiselectGrupoRestricao`)"
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione a restrição à ser atualizada</label
                      >
                      <Multiselect
                        :id="`multiselectRestricaoAdministrativa`"
                        :ref="`multiselectRestricaoAdministrativa`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione a restrição à ser atualizada"
                        v-model="this.restricaoAdministrativaSelecionada"
                        :searchable="true"
                        :canDeselect="true"
                        :options="
                          this.camposOrdenados(
                            this.restricoesAdministrativasPadrao
                          )
                        "
                        placeholder="Atualizar todas as restrições do grupo"
                        @clear="
                          this.focusSelect(`multiselectRestricaoAdministrativa`)
                        "
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto mb-4">
                    <div class="fv-row">
                      <button
                        @click="confirmarGrupoRestricaoAdministrativa()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Iniciar a atualização da restrição do grupo"
                        class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-5"
                      >
                        <i class="bi bi-check-lg ms-1 fs-2"></i>
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card border border-rounded border-gray-300 mb-0 p-6">
                <h4 class="text-primary ms-4 mb-4">
                  Restrições de Usuários Padrão
                </h4>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione a restrição à ser atualizada</label
                      >
                      <Multiselect
                        :id="`multiselectRestricaoEmitentePadrao`"
                        :ref="`multiselectRestricaoEmitentePadrao`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione a restrição à ser atualizada"
                        v-model="this.restricaoEmitentePadraoSelecionada"
                        :searchable="true"
                        :canDeselect="true"
                        :options="
                          this.camposOrdenados(this.restricoesEmitentePadrao)
                        "
                        @clear="
                          this.focusSelect(`multiselectRestricaoEmitentePadrao`)
                        "
                        placeholder="Atualizar todas as restrições"
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-auto mb-4">
                    <div class="fv-row">
                      <button
                        @click="confirmarRestricaoEmitentePadrao()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Iniciar a atualização da restrição"
                        class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-5"
                      >
                        <i class="bi bi-check-lg ms-1 fs-2"></i>
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
                <h4 class="text-primary ms-4 mb-4">
                  Grupo de Restrições de Usuários
                </h4>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione o grupo de restrição à ser atualizado</label
                      >
                      <Multiselect
                        :id="`multiselectGrupoRestricaoEmitente`"
                        :ref="`multiselectGrupoRestricaoEmitente`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione o grupo de restrição à ser atualizado"
                        v-model="this.grupoRestricaoEmitenteSelecionado"
                        :searchable="true"
                        :canDeselect="true"
                        :options="
                          this.retornaOptionsTipo(this.tipoUsuarioEmitente)
                        "
                        placeholder="Atualizar todos os grupos"
                        @clear="
                          this.focusSelect(`multiselectGrupoRestricaoEmitente`)
                        "
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                    <div class="fv-row mb-4">
                      <label class="form-label me-4"
                        >Selecione a restrição à ser atualizada</label
                      >
                      <Multiselect
                        :id="`multiselectRestricaoEmitente`"
                        :ref="`multiselectRestricaoEmitente`"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Selecione a restrição à ser atualizada"
                        v-model="this.restricaoEmitenteSelecionada"
                        :searchable="true"
                        :canDeselect="true"
                        :options="
                          this.camposOrdenados(this.restricoesEmitentePadrao)
                        "
                        placeholder="Atualizar todas as restrições do grupo"
                        @clear="
                          this.focusSelect(`multiselectRestricaoEmitente`)
                        "
                      >
                        <template v-slot:singlelabel="{ value }">
                          <div class="multiselect-single-label">
                            {{ value.label }}
                          </div>
                        </template>
                        <template v-slot:option="{ option }">
                          {{ option.label }}
                        </template>
                        <template v-slot:noresults="{}">
                          <div class="m-4">
                            {{ "Nenhum resultado foi encontrado" }}
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto mb-4">
                    <div class="fv-row">
                      <button
                        @click="confirmarGrupoRestricaoEmitente()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Iniciar a atualização da restrição do grupo"
                        class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-5"
                      >
                        <i class="bi bi-check-lg ms-1 fs-2"></i>
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mTabelaIbpt'"
          class="card-body pt-5"
        >
          <a href="#" id="idmTabelaIbpt"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div v-if="getVigenciaExpirou()" class="fv-row">
                <div
                  class="alert bg-light-danger d-flex flex-column flex-sm-row p-5 mb-10"
                >
                  <span class="svg-icon svg-icon-danger svg-icon-2tx me-4">
                    <inline-svg src="media/icons/duotune/general/gen044.svg" />
                  </span>
                  <div class="d-flex flex-column pe-0 pe-sm-10 mb-2">
                    <h4 class="fw-semibold">
                      {{
                        "A Tabela IBPT está desatualizada! Expirou dia: " +
                        this.$utils.formatarData(
                          this.versaoTabelaIbpt.vigencia_final
                        ) +
                        " - Versão: " +
                        this.versaoTabelaIbpt.versao
                      }}
                    </h4>
                    <span
                      >Verifique se já existe uma nova versão disponível no
                      site:
                      <a
                        target="_blank"
                        href="https://deolhonoimposto.ibpt.org.br"
                        >https://deolhonoimposto.ibpt.org.br</a
                      >, é importante manter atualizada para garantir a
                      eficiência da validação.</span
                    >
                  </div>
                </div>
              </div>
              <div v-else class="fv-row">
                <div
                  class="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10"
                >
                  <span class="svg-icon svg-icon-primary svg-icon-2tx me-4">
                    <inline-svg src="media/icons/duotune/general/gen044.svg" />
                  </span>
                  <div class="d-flex pe-0 pe-sm-10 align-items-center">
                    <h4 class="fw-semibold m-0">
                      {{
                        "A Tabela IBPT está atualizada! Vigência final: " +
                        this.$utils.formatarData(
                          this.versaoTabelaIbpt.vigencia_final
                        ) +
                        " - Versão: " +
                        this.versaoTabelaIbpt.versao
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <h4 class="text-primary ms-4">Atualizar Tabela Ibpt</h4>
              <div class="row">
                <div class="col-auto mb-4">
                  <button
                    class="btn btn-sm btn-light-info"
                    @click="atualizarTabelaIbpt()"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
                    </span>
                    Atualizar Tabela Ibpt
                  </button>
                </div>
                <div class="col-auto mb-4">
                  <button
                    class="btn btn-sm btn-light-primary"
                    @click="abrirVersaoTabelaIbpt()"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg src="media/icons/duotune/coding/cod003.svg" />
                    </span>
                    Atualizar Versão Tabela Ibpt
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            this.idMenuSelecionado === 'mAgenciaBoletoLicenca' &&
            this.exibirAgenciaBoletoLicenca
          "
          class="card-body pt-5"
        >
          <a href="#" id="idmAgenciaBoletoLicenca"></a>
          <div class="row">
            <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
              <button
                v-if="this.adicionarAgenciaBoletoLicenca"
                type="button"
                class="btn btn-sm btn-primary"
                @click="this.adicionarAgenciaBoletoLicencaModal()"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/general/gen041.svg" /></span
                >Adicionar
              </button>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <Datatable
                ref="tableAgenciaBoletoLicenca"
                :table-header="tableHeaderAgenciaBoletoLicenca"
                :table-data="tableDataAgenciaBoletoLicenca"
                :table-pagination="tablePaginationAgenciaBoletoLicenca"
                :page-sizes="pageSizesAgenciaBoletoLicenca"
                :enable-items-per-page-dropdown="true"
                :hide-on-single-page="false"
                empty-table-text="Nenhum registro foi encontrado"
                :colors="true"
              >
                <template v-slot:cell-id="{ row: data }">
                  {{ data.id }}
                </template>
                <template v-slot:cell-banco="{ row: data }">
                  {{ data.banco }}
                </template>
                <template v-slot:cell-nome_banco="{ row: data }">
                  <div
                    class="min-w-150px text-gray-800 text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
                  >
                    {{ data.nome_banco }}
                  </div>
                </template>
                <template v-slot:cell-conta="{ row: data }">
                  {{
                    data
                      ? data.conta +
                        (data.dv_conta === null ? "" : "-" + data.dv_conta)
                      : ""
                  }}
                </template>
                <template v-slot:cell-agencia="{ row: data }">
                  {{
                    data.agencia +
                    (data.dv_agencia === null ? "" : "-" + data.dv_agencia)
                  }}
                </template>
                <template v-slot:cell-nosso_numero="{ row: data }">
                  {{ data.nosso_numero }}
                </template>
                <template v-slot:cell-acoes="{ row: data }">
                  <div
                    class="d-flex flex-row-fluid justify-content-end flex-shrink-0 gap-3"
                  >
                    <button
                      class="btn btn-sm btn-light btn-active-light-primary"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                      data-kt-menu-flip="top-end"
                    >
                      Ações
                      <span class="svg-icon svg-icon-5 m-0">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr072.svg"
                        />
                      </span>
                    </button>
                    <div
                      v-if="
                        this.editarAgenciaBoletoLicenca ||
                        this.excluirAgenciaBoletoLicenca
                      "
                      class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                      data-kt-menu="true"
                    >
                      <div
                        v-if="this.editarAgenciaBoletoLicenca"
                        class="menu-item px-3"
                      >
                        <a
                          @click="editarRegistroAgenciaBoletoLicenca(data.id)"
                          class="menu-link px-3"
                          ><span class="svg-icon svg-icon-1 align-self-center">
                            <inline-svg
                              src="media/icons/duotune/art/art005.svg"
                              class="me-2"
                            />Editar
                          </span></a
                        >
                      </div>
                      <div
                        v-if="this.excluirAgenciaBoletoLicenca"
                        class="menu-item px-3"
                      >
                        <a
                          @click="removerRegistroAgenciaBoletoLicenca(data)"
                          class="menu-link px-3"
                          ><span class="svg-icon svg-icon-1 align-self-center">
                            <inline-svg
                              src="media/icons/duotune/arrows/arr015.svg"
                              class="me-2"
                            />Excluir
                          </span></a
                        >
                      </div>
                    </div>
                  </div>
                </template>
              </Datatable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AtualizarTabelaIbptModal
    v-if="exibirAtualizarTabelaIbpt"
    @exibirModalTabelaIbptAtualizar="modalAtualizarTabelaIbpt"
  ></AtualizarTabelaIbptModal>
  <VersaoTabelaIbptModal
    v-if="exibirVersaoTabelaIbpt"
    @exibirModalVersaoTabelaIbpt="modalVersaoTabelaIbpt"
    @confirmarVersaoTabelaIbpt="verificarVersaoAtual"
  ></VersaoTabelaIbptModal>
  <LoadingModal
    :nomeRef="'loadingModalPainelGestor'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
  <EditarAgenciaBoletoLicencaModal
    v-if="exibirModalEditarAgenciaBoletoLicenca"
    :id="this.idAgenciaBoletoLicenca"
    @exibirEditarAgenciaBoletoLicencaModal="
      exibirEditarAgenciaBoletoLicencaModal
    "
    @confirmarEditarAgenciaBoletoLicencaModal="
      confirmarEditarAgenciaBoletoLicencaModal
    "
  ></EditarAgenciaBoletoLicencaModal>
</template>

<script>
import AtualizarTabelaIbptModal from "@/views/produtos/AtualizarTabelaIbptModal.vue";
import VersaoTabelaIbptModal from "@/views/produtos/VersaoTabelaIbptModal.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Multiselect from "@vueform/multiselect";
import { useToast } from "vue-toastification";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import EditarAgenciaBoletoLicencaModal from "@/views/gestor/EditarAgenciaBoletoLicencaModal.vue";
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";
import { mapState } from "vuex";

const toast = useToast();

export default {
  components: {
    AtualizarTabelaIbptModal,
    VersaoTabelaIbptModal,
    Multiselect,
    LoadingModal,
    Datatable,
    EditarAgenciaBoletoLicencaModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async focusSelect(campo) {
      await this.sleep(100);
      var element = this.$refs[campo];
      if (element) {
        element.open();
      }
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalPainelGestor");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalPainelGestor");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showErrorAlert(text) {
      await Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async confirmarRestricaoAdministrativaPadrao() {
      await this.exibirModalLoading(true);
      try {
        var filtroRegra = this.restricaoAdministrativaPadraoSelecionada
          ? "&regra=" + this.restricaoAdministrativaPadraoSelecionada
          : "";
        var ret = await this.$store.dispatch(
          "administrador/addRestricoesPadrao",
          "?" + filtroRegra
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        if (error.Message) {
          await this.showErrorAlert(error.Message);
        }
      }
    },
    async confirmarGrupoRestricaoAdministrativa() {
      await this.exibirModalLoading(true);
      try {
        var filtroTipo = this.grupoRestricaoSelecionado
          ? "&tipo=" + this.grupoRestricaoSelecionado
          : "";
        var filtroRegra = this.restricaoAdministrativaSelecionada
          ? "&regra=" + this.restricaoAdministrativaSelecionada
          : "";
        var ret = await this.$store.dispatch(
          "administrador/addRestricoes",
          "?" + filtroTipo + filtroRegra
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        if (error.Message) {
          await this.showErrorAlert(error.Message);
        }
      }
    },
    async confirmarRestricaoEmitentePadrao() {
      await this.exibirModalLoading(true);
      try {
        var filtroRegra = this.restricaoEmitentePadraoSelecionada
          ? "&regra=" + this.restricaoEmitentePadraoSelecionada
          : "";
        var ret = await this.$store.dispatch(
          "administrador/addEmitenteRestricoesPadrao",
          "?" + filtroRegra
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        if (error.Message) {
          await this.showErrorAlert(error.Message);
        }
      }
    },
    async confirmarGrupoRestricaoEmitente() {
      await this.exibirModalLoading(true);
      try {
        var filtroTipo = this.grupoRestricaoEmitenteSelecionado
          ? "&tipo=" + this.grupoRestricaoEmitenteSelecionado
          : "";
        var filtroRegra = this.restricaoEmitenteSelecionada
          ? "&regra=" + this.restricaoEmitenteSelecionada
          : "";
        var ret = await this.$store.dispatch(
          "administrador/addEmitenteRestricoes",
          "?" + filtroTipo + filtroRegra
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        if (error.Message) {
          await this.showErrorAlert(error.Message);
        }
      }
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.descricao.toUpperCase();
        const descricaoB = b.descricao.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const objetoOrdenado = objeto.sort((a, b) => compararPorDescricao(a, b));

      const transformedJson = [];
      for (const key in objetoOrdenado) {
        transformedJson.push({
          value: objetoOrdenado[key].regra,
          label:
            objetoOrdenado[key].descricao + " | " + objetoOrdenado[key].regra,
          objeto: objetoOrdenado[key],
        });
      }

      return transformedJson;
    },
    retornaOptionsTipo(objeto) {
      const transformedJson = [];
      for (const key in objeto) {
        transformedJson.push({
          value: objeto[key].tipo,
          label: objeto[key].tipo,
          objeto: objeto[key],
        });
      }

      return transformedJson;
    },
    abrirVersaoTabelaIbpt() {
      this.modalVersaoTabelaIbpt(true);
    },
    modalVersaoTabelaIbpt(exibir) {
      this.exibirVersaoTabelaIbpt = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_versao_tabela_ibpt");
        }, 100);
      }
    },
    atualizarTabelaIbpt() {
      this.modalAtualizarTabelaIbpt(true);
    },
    modalAtualizarTabelaIbpt(exibir) {
      this.exibirAtualizarTabelaIbpt = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_tabela_ibpt_atualizar");
        }, 100);
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    menuClick(id) {
      this.idMenuSelecionado = id;
      setTimeout(() => {
        this.nextFocus("id" + this.idMenuSelecionado);
      }, 100);
      var doc = document.getElementById(this.idMenuSelecionado);
      if (
        doc.parentElement.parentElement.classList.contains(
          "menu-sub-accordion"
        ) === false
      ) {
        var docs = document
          .getElementById("menuPainelGestor")
          .getElementsByClassName("menu-accordion");
        if (docs != null) {
          for (var i = 0; i < docs.length; i++) {
            docs[i].classList.remove("show");
            docs[i].classList.remove("hover");
            docs[i]
              .getElementsByClassName("menu-sub-accordion")[0]
              .classList.remove("show");
          }
        }
      }
    },
    returnTitle() {
      var doc = document.getElementById(this.idMenuSelecionado);
      if (doc !== null) {
        return doc.getElementsByClassName("menu-title")[0].innerText;
      } else {
        return "";
      }
    },
    getVigenciaExpirou() {
      var data_final = new Date(this.versaoTabelaIbpt.vigencia_final);
      var data_atual = new Date();
      return data_final < data_atual;
    },
    async verificarVigenciaFinal(versaoAtual) {
      var vigencia = null;
      try {
        var ret = await this.$store.dispatch("ibpt/getVersoesAgrupadas");
        if (ret.Success === true && ret.Data.length > 0) {
          var versoes = ret.Data;

          versoes.forEach(function (ibpt) {
            if (ibpt.versao == versaoAtual.versao) {
              vigencia = ibpt.vigencia_final;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
      return vigencia;
    },
    async verificarVersaoAtual() {
      try {
        var ret = await this.$store.dispatch(
          "versaoTabelaIbpt/getVersaoTabelaIbptOData",
          ""
        );
        if (ret !== null && ret.value.length > 0) {
          this.versaoTabelaIbpt = ret.value[0];
          this.versaoTabelaIbpt.vigencia_final =
            await this.verificarVigenciaFinal(this.versaoTabelaIbpt);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRestricoesAdministrativasPadrao() {
      try {
        var ret = await this.$store.dispatch(
          "administrador/getRestricoesPadrao"
        );
        if (ret.Success === true && ret.Data.length > 0) {
          this.restricoesAdministrativasPadrao = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRestricoesEmitentePadrao() {
      try {
        var ret = await this.$store.dispatch(
          "administrador/getEmitenteRestricoesPadrao"
        );
        if (ret.Success === true && ret.Data.length > 0) {
          this.restricoesEmitentePadrao = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarTipoUsuario() {
      try {
        var retOdata = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuarioOData",
          "?$select=tipo&$orderby=tipo asc"
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.tipoUsuario = retOdata.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.AgenciaBoletoLicenca.Consultar") {
            this.exibirAgenciaBoletoLicenca = true;
          }
          if (element.regra === "Permitir.AgenciaBoletoLicenca.Incluir") {
            this.adicionarAgenciaBoletoLicenca = true;
          }
          if (element.regra === "Permitir.AgenciaBoletoLicenca.Alterar") {
            this.editarAgenciaBoletoLicenca = true;
          }
          if (element.regra === "Permitir.AgenciaBoletoLicenca.Excluir") {
            this.excluirAgenciaBoletoLicenca = true;
          }
        });
      }
    },
    async adicionarAgenciaBoletoLicencaModal() {
      this.idAgenciaBoletoLicenca = -1;
      this.exibirEditarAgenciaBoletoLicencaModal(true);
    },

    exibirEditarAgenciaBoletoLicencaModal(exibir) {
      this.exibirModalEditarAgenciaBoletoLicenca = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_agencia_boleto_licenca_editar");
        }, 100);
      }
    },

    async confirmarEditarAgenciaBoletoLicencaModal() {
      this.$refs.tableAgenciaBoletoLicenca.setLoading(true);
      this.$refs.tableAgenciaBoletoLicenca.load();
      this.exibirModalEditarAgenciaBoletoLicenca = false;
    },

    editarRegistroAgenciaBoletoLicenca(id) {
      this.idAgenciaBoletoLicenca = id;
      this.exibirEditarAgenciaBoletoLicencaModal(true);
    },
    async removerRegistroAgenciaBoletoLicenca(data) {
      if (this.user.User.TipoUsuario.tipo === "Administrador") {
        var alert = await Swal.fire({
          text: "Deseja remover o registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          this.errosValidacaoGeral = [];
          this.excluiu = true;
          this.$refs.tableAgenciaBoletoLicenca.setLoading(true);

          await this.$store.dispatch(
            "agenciaBoletoLicenca/deleteAgenciaBoletoLicenca",
            data.id
          );

          toast.success("Registro excluído com sucesso!", {
            timeout: 3000,
          });

          this.$refs.tableAgenciaBoletoLicenca.load();
        }
      } else {
        await Swal.fire({
          text: "Não é possível remover a agência!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
    },
  },
  async mounted() {
    await this.exibirModalLoading(true);
    await this.verificarVersaoAtual();
    await this.getRestricoesAdministrativasPadrao();
    await this.getRestricoesEmitentePadrao();
    await this.carregarTipoUsuario();
    await this.verificarRestricoes();
    this.idMenuSelecionado = "mAtualizaBase";
    await this.exibirModalLoading(false);
  },
  data() {
    return {
      timeOut: null,
      restricaoAdministrativaPadraoSelecionada: "",
      restricoesAdministrativasPadrao: {},
      grupoRestricaoSelecionado: "",
      tipoUsuario: [],
      restricaoAdministrativaSelecionada: "",
      restricaoEmitentePadraoSelecionada: "",
      restricoesEmitentePadrao: {},
      grupoRestricaoEmitenteSelecionado: "",
      tipoUsuarioEmitente: [
        {
          tipo: "Administrador",
        },
      ],
      restricaoEmitenteSelecionada: "",
      versaoTabelaIbpt: {
        id: 0,
        versao: "",
        vigencia_final: null,
      },
      exibirAtualizarTabelaIbpt: false,
      exibirVersaoTabelaIbpt: false,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      loading: false,
      idMenuSelecionado: "",
      exibirAgenciaBoletoLicenca: false,
      adicionarAgenciaBoletoLicenca: false,
      editarAgenciaBoletoLicenca: false,
      excluirAgenciaBoletoLicenca: false,
      exibirModalEditarAgenciaBoletoLicenca: false,
      idAgenciaBoletoLicenca: -1,
      tableHeaderAgenciaBoletoLicenca: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Banco",
          key: "banco",
          sortable: true,
        },
        {
          name: "Nome Banco",
          key: "nome_banco",
          sortable: true,
          sortingField: "nome_banco",
        },
        {
          name: "Conta",
          key: "conta",
          sortable: true,
        },
        {
          name: "Agência",
          key: "agencia",
          sortable: true,
        },
        {
          name: "Nosso Número",
          key: "nosso_numero",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableDataAgenciaBoletoLicenca: {
        store: "agenciaBoletoLicenca/getAgenciaBoletoLicencaOData",
        selectOData:
          "?$select=id,conta,dv_conta,banco,agencia,dv_agencia,nome_banco,nosso_numero",
        filterOData: "",
        search: "",
        defaultSort: "id desc",
      },
      tablePaginationAgenciaBoletoLicenca: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizesAgenciaBoletoLicenca: [
        "5",
        "10",
        "15",
        "20",
        "30",
        "50",
        "100",
        "Todos",
      ],
    };
  },
};
</script>

<style>
.multiselect > * {
  font-size: 0.925rem;
  border-radius: 0.425rem;
  font-weight: 500;
  line-height: 1.5;
}
.multiselect-option.is-pointed.is-selected {
  background: hwb(219 31% 26%);
}
.multiselect-option.is-selected {
  background: hwb(219 31% 26%);
}
.is-single .multiselect-search input {
  padding: 0px 0px 0px 14px;
  font-size: 0.925rem;
}
.multiselect-input {
  min-height: 34px;
}
.multiselect-single-label {
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap !important;
  padding-right: 10px !important;
}
.multiselect-input input {
  min-height: 34px;
}
.multiselect-clear {
  position: absolute;
  right: 4px;
  top: 50%;
  width: 34px;
  height: 34px;
  background: transparent;
}
</style>
